const TileSize = 32

export {
	TileSize
}
